import React from 'react';

export const SVGTopNavDirectoryExpand: React.FC = () => {
    return (<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M13.22 10.528l-4.223 4.224a.742.742 0 01-1.053 0l-.702-.702a.742.742 0 010-1.053l2.994-2.994L7.242 7.01a.742.742 0 010-1.052l.699-.709a.742.742 0 011.053 0l4.223 4.224a.743.743 0 01.003 1.056z" fill="#fff"/></svg>)
};

